import { useAuth } from 'hooks/useAuth';

export const useLoginMethod = () => {
    const auth = useAuth();
    return () => {
        const providers = auth?.user?.providerIds;
        if (!providers) return 'unknown';
        if (providers.includes('google.com') && providers.includes('password'))
            return 'Google and password';
        if (providers.includes('google.com')) return 'Google';
        if (providers.includes('password')) return 'password';
        if (providers.includes('microsoft.com')) return 'Microsoft';
        return 'unknown';
    };
};
